import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterByAddressPipe } from './filter-by-address.pipe';
import { FullControlFilterPipe } from './full-control.pipe';
import { MprdTranslatePipe } from './mprd-translate.pipe';
import { ChargeFrequencyPipe } from './charge-frequency.pipe';
import { FilterByOptionCategoryPipe } from './filter-by-option-category.pipe';
import { ExcludeFavAppOptionsPipe } from './exclude-fav-app-options.pipe';
import { FilterHiddenPipe } from './filter-hidden.pipe';
import { FilterActiveFavAppPipe } from './filter-active-fav-app.pipe';
import { LanguageRestrictionPipe } from './language-restriction.pipe';
import { AsteriskReplacerPipe } from './asterisk-replacer.pipe';
import { RemoveDuplicateProductsPipe } from './remove-duplicate-products.pipe';
import { AggregateNortonProductsPipe } from './aggregate-norton-products.pipe';
import { ExcludeFlexEmergencyPipe } from './exclude-flex-emergency.pipe';

@NgModule({
  declarations: [
    FilterByAddressPipe,
    FullControlFilterPipe,
    MprdTranslatePipe,
    ChargeFrequencyPipe,
    FilterByOptionCategoryPipe,
    ExcludeFavAppOptionsPipe,
    FilterHiddenPipe,
    FilterActiveFavAppPipe,
    LanguageRestrictionPipe,
    AsteriskReplacerPipe,
    RemoveDuplicateProductsPipe,
    AggregateNortonProductsPipe,
    ExcludeFlexEmergencyPipe,
  ],
  imports: [CommonModule],
  exports: [
    FilterByAddressPipe,
    FullControlFilterPipe,
    MprdTranslatePipe,
    ChargeFrequencyPipe,
    FilterByOptionCategoryPipe,
    ExcludeFavAppOptionsPipe,
    FilterHiddenPipe,
    FilterActiveFavAppPipe,
    LanguageRestrictionPipe,
    AsteriskReplacerPipe,
    RemoveDuplicateProductsPipe,
    AggregateNortonProductsPipe,
    ExcludeFlexEmergencyPipe,
  ],
})
export class PipeModule {}
